import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssessmentGroupInfo } from 'app/models/evaluation/assessment-group-info.model';

@Component({
  selector: 'app-one-to-three-scale-edit',
  templateUrl: './one-to-three-scale-edit.component.html',
  styleUrls: ['./one-to-three-scale-edit.component.scss']
})
export class OneToThreeScaleEditComponent {
  @Input() assessmentGroups: AssessmentGroupInfo[] = [];
  @Output() savedEmit: EventEmitter<AssessmentGroupInfo[]> = new EventEmitter<AssessmentGroupInfo[]>();

  saveFields() {
    this.savedEmit.emit(this.assessmentGroups);
  }
}
